<template>
  <AppLayout>
    <div class="p-4 md:p-6">

      <!-- Header (desktop only) -->
      <div class="hidden md:flex items-center justify-between mb-2">
        <div>
          <h1 class="text-2xl font-bold text-slate-800 dark:text-white">Products</h1>
          <p class="text-slate-500 dark:text-slate-400 text-sm mt-0.5">
            <span v-if="loading" class="inline-block w-24 h-3 bg-slate-200 dark:bg-slate-700 rounded-full animate-pulse"></span>
            <span v-else>{{ filtered.length }} of {{ products.length }} product{{ products.length !== 1 ? 's' : '' }}</span>
          </p>
        </div>
        <div class="flex items-center gap-2">
          <button @click="showPurchasePrice = !showPurchasePrice"
            :title="showPurchasePrice ? 'Hide purchase price' : 'Show purchase price'"
            class="w-9 h-9 flex items-center justify-center rounded-xl border transition"
            :class="showPurchasePrice
              ? 'bg-indigo-50 dark:bg-indigo-950 border-indigo-200 dark:border-indigo-800 text-indigo-600 dark:text-indigo-400'
              : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300'">
            <svg v-if="showPurchasePrice" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            <svg v-else class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
            </svg>
          </button>
          <button @click="openAdd"
            class="flex items-center gap-2 bg-indigo-500 hover:bg-indigo-400 active:scale-95 text-white
                   text-sm font-semibold px-4 py-2.5 rounded-xl shadow-sm shadow-indigo-500/30 transition">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
            </svg>
            Add Product
          </button>
        </div>
      </div>

      <!-- ── MOBILE HEADER ── -->
      <div class="md:hidden -mx-4 -mt-4 mb-1">
        <!-- Gradient hero -->
        <div class="bg-gradient-to-br from-indigo-600 via-indigo-500 to-violet-500 px-4 pt-3 pb-6">
          <div class="flex items-center justify-between mb-3">
            <div>
              <h1 class="text-xl font-bold text-white">Products</h1>
              <p class="text-indigo-200 text-xs mt-0.5">
                <span v-if="loading">Loading...</span>
                <span v-else>{{ filtered.length }} of {{ products.length }} product{{ products.length !== 1 ? 's' : '' }}</span>
              </p>
            </div>
            <div class="flex items-center gap-2">
              <!-- Toggle purchase price -->
              <button @click="showPurchasePrice = !showPurchasePrice"
                class="w-9 h-9 flex items-center justify-center rounded-xl transition"
                :class="showPurchasePrice ? 'bg-white/30 text-white' : 'bg-white/15 text-white/70'">
                <svg v-if="showPurchasePrice" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
                <svg v-else class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
                </svg>
              </button>
              <button @click="openAdd"
                class="flex items-center gap-1.5 bg-white/20 active:bg-white/30 text-white text-sm font-semibold px-4 py-2.5 rounded-xl transition">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
                </svg>
                Add
              </button>
            </div>
          </div>
          <!-- Stats row -->
          <div v-if="!loading" class="grid gap-2 mb-2" :class="showPurchasePrice ? 'grid-cols-3' : 'grid-cols-2'">
            <div class="bg-white/15 backdrop-blur-sm rounded-2xl px-3 py-3 text-center">
              <p class="text-[9px] font-bold text-indigo-200 uppercase tracking-widest mb-1">Products</p>
              <p class="text-sm font-bold text-white">{{ products.length }}</p>
            </div>
            <div class="bg-white/15 backdrop-blur-sm rounded-2xl px-3 py-3 text-center">
              <p class="text-[9px] font-bold text-emerald-200 uppercase tracking-widest mb-1">Sale Value</p>
              <p class="text-sm font-bold text-white whitespace-nowrap">Rs {{ Math.floor(totalSaleAmount).toLocaleString('en-PK') }}</p>
            </div>
            <div v-if="showPurchasePrice" class="bg-white/15 backdrop-blur-sm rounded-2xl px-3 py-3 text-center">
              <p class="text-[9px] font-bold text-violet-200 uppercase tracking-widest mb-1">Buy Value</p>
              <p class="text-sm font-bold text-white whitespace-nowrap">Rs {{ Math.floor(totalPurchaseAmount).toLocaleString('en-PK') }}</p>
            </div>
          </div>
          <div v-else class="grid grid-cols-2 gap-2 mb-2">
            <div v-for="i in 2" :key="i" class="bg-white/15 rounded-2xl h-14 animate-pulse"></div>
          </div>
        </div>

        <!-- Search card pulls up over hero -->
        <div class="bg-gray-50 dark:bg-slate-950 rounded-t-3xl -mt-4 px-4 pt-3 pb-2">
          <div class="relative">
            <svg class="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none"
              fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607z"/>
            </svg>
            <input v-model="search" type="text" placeholder="Search products..."
              :disabled="loading"
              class="w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700
                     text-slate-800 dark:text-white placeholder-slate-400 rounded-2xl pl-10 pr-10 py-3 text-sm
                     focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm transition disabled:opacity-50" />
            <button v-if="search" @click="search = ''"
              class="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-400">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Search + Stats (desktop only) -->
      <div class="hidden md:flex items-center gap-3 mb-3">
        <div class="relative w-56 shrink-0">
          <svg class="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none"
            fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607z"/>
          </svg>
          <input
            v-model="search"
            type="text"
            placeholder="Search..."
            :disabled="loading"
            class="w-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700
                   text-slate-800 dark:text-white placeholder-slate-400 rounded-xl pl-10 pr-10 py-2.5 text-sm
                   focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition disabled:opacity-50"
          />
          <button v-if="search" @click="search = ''"
            class="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <!-- Spacer -->
        <div class="flex-1"></div>

        <!-- Stats -->
        <div class="hidden md:flex items-center gap-2">
          <template v-if="loading">
            <div class="h-10 w-28 bg-slate-100 dark:bg-slate-800 rounded-xl animate-pulse"></div>
            <div class="h-10 w-28 bg-slate-100 dark:bg-slate-800 rounded-xl animate-pulse"></div>
          </template>
          <template v-else>
            <div v-if="showPurchasePrice" class="bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl px-4 py-2 text-right">
              <p class="text-[10px] font-semibold text-slate-400 uppercase tracking-wide">Purchase Value</p>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-300">Rs {{ formatNum(totalPurchaseAmount) }}</p>
            </div>
            <div class="bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-xl px-4 py-2 text-right">
              <p class="text-[10px] font-semibold text-emerald-500 uppercase tracking-wide">Sale Value</p>
              <p class="text-sm font-bold text-emerald-600 dark:text-emerald-400">Rs {{ formatNum(totalSaleAmount) }}</p>
            </div>
          </template>
        </div>
      </div>

      <!-- Flash -->
      <div v-if="$page.props.flash?.notice" class="mb-4 flex items-center gap-2 bg-green-50 dark:bg-green-950 text-green-700 dark:text-green-400 text-sm px-4 py-3 rounded-xl">
        <svg class="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        {{ $page.props.flash.notice }}
      </div>
      <div v-if="$page.props.flash?.alert || errors?.length" class="mb-4 bg-red-50 dark:bg-red-950 text-red-600 dark:text-red-400 text-sm px-4 py-3 rounded-xl">
        <p v-if="$page.props.flash?.alert">• {{ $page.props.flash.alert }}</p>
        <p v-for="e in (errors || [])" :key="e">• {{ e }}</p>
      </div>

      <!-- Skeleton -->
      <template v-if="loading">
        <!-- Desktop skeleton -->
        <div class="hidden md:block bg-white dark:bg-slate-900 rounded-2xl border border-slate-100 dark:border-slate-800 overflow-hidden">
          <div class="border-b border-slate-100 dark:border-slate-800 px-5 py-3.5 flex gap-6">
            <div v-for="i in 6" :key="i" class="h-2.5 w-16 bg-slate-100 dark:bg-slate-800 rounded-full animate-pulse"></div>
          </div>
          <div v-for="i in 8" :key="i" class="flex items-center gap-6 px-5 py-4 border-b border-slate-50 dark:border-slate-800/50">
            <div class="h-3 w-4 bg-slate-100 dark:bg-slate-800 rounded-full animate-pulse shrink-0"></div>
            <div class="h-3 w-32 bg-slate-100 dark:bg-slate-800 rounded-full animate-pulse flex-1"></div>
            <div class="h-3 w-20 bg-slate-100 dark:bg-slate-800 rounded-full animate-pulse ml-auto"></div>
            <div class="h-6 w-12 bg-slate-100 dark:bg-slate-800 rounded-lg animate-pulse"></div>
            <div class="h-3 w-24 bg-slate-100 dark:bg-slate-800 rounded-full animate-pulse"></div>
            <div class="h-6 w-12 bg-slate-100 dark:bg-slate-800 rounded-lg animate-pulse"></div>
          </div>
        </div>
        <!-- Mobile skeleton -->
        <div class="md:hidden space-y-3">
          <div v-for="i in 5" :key="i"
            class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-100 dark:border-slate-800 p-4 space-y-3">
            <div class="flex items-center justify-between">
              <div class="h-4 w-36 bg-slate-100 dark:bg-slate-800 rounded-full animate-pulse"></div>
              <div class="h-7 w-14 bg-slate-100 dark:bg-slate-800 rounded-lg animate-pulse"></div>
            </div>
            <div class="grid grid-cols-3 gap-2">
              <div v-for="j in 3" :key="j" class="h-14 bg-slate-100 dark:bg-slate-800 rounded-xl animate-pulse"></div>
            </div>
          </div>
        </div>
      </template>

      <!-- Empty state -->
      <div v-else-if="filtered.length === 0"
        class="flex flex-col items-center justify-center py-20 text-center">
        <div class="w-16 h-16 rounded-2xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center mb-4">
          <svg class="w-8 h-8 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3 3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"/>
          </svg>
        </div>
        <p class="text-slate-600 dark:text-slate-400 font-medium">
          {{ search ? 'No products match your search' : 'No products yet' }}
        </p>
        <p class="text-slate-400 dark:text-slate-500 text-sm mt-1">
          {{ search ? 'Try a different keyword' : 'Add your first product to get started' }}
        </p>
        <button v-if="!search" @click="openAdd" class="mt-4 text-indigo-500 text-sm font-semibold hover:text-indigo-400 transition">+ Add Product</button>
        <button v-else @click="search = ''" class="mt-4 text-indigo-500 text-sm font-semibold hover:text-indigo-400 transition">Clear search</button>
      </div>

      <!-- Desktop table -->
      <div v-else class="hidden md:block bg-white dark:bg-slate-900 rounded-2xl border border-slate-100 dark:border-slate-800 overflow-visible">
        <table class="w-full text-sm">
          <thead>
            <tr class="border-b border-slate-100 dark:border-slate-800">
              <th class="text-left px-5 py-3.5 text-xs font-semibold text-slate-400 uppercase tracking-wide w-10">#</th>
              <th class="text-left px-5 py-3.5 text-xs font-semibold text-slate-400 uppercase tracking-wide">Product</th>
              <th class="text-right px-5 py-3.5 text-xs font-semibold text-slate-400 uppercase tracking-wide">Rate</th>
              <th class="text-center px-5 py-3.5 text-xs font-semibold uppercase tracking-wide cursor-pointer select-none"
                :class="sortDir ? 'text-indigo-500' : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300'"
                @click="toggleSort">
                <span class="inline-flex items-center justify-center gap-1">
                  Stock
                  <svg class="w-3 h-3 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"
                    :class="sortDir === 'asc' ? 'rotate-180' : ''">
                    <path v-if="sortDir" stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
                    <path v-else stroke-linecap="round" stroke-linejoin="round" d="M8 9l4-4 4 4m0 6l-4 4-4-4"/>
                  </svg>
                </span>
              </th>
              <th class="text-right px-5 py-3.5 text-xs font-semibold text-slate-400 uppercase tracking-wide">Sale Amount</th>
              <th class="text-center px-5 py-3.5 text-xs font-semibold text-slate-400 uppercase tracking-wide">Actions</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(product, i) in filtered" :key="product.id">
              <!-- Main row -->
              <tr @click="toggleExpand(product.id)"
                class="cursor-pointer border-t border-slate-50 dark:border-slate-800 transition"
                :class="expandedId === product.id
                  ? 'bg-indigo-50/50 dark:bg-indigo-950/20'
                  : 'hover:bg-slate-50 dark:hover:bg-slate-800/50'">
                <td class="px-5 py-4 text-slate-400 text-xs">{{ i + 1 }}</td>
                <td class="px-5 py-4">
                  <div class="flex items-center gap-2">
                    <svg class="w-3.5 h-3.5 text-slate-400 shrink-0 transition-transform duration-200"
                      :class="expandedId === product.id ? 'rotate-90 text-indigo-500' : ''"
                      fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
                    </svg>
                    <span class="font-semibold text-slate-800 dark:text-white">{{ product.name }}</span>
                  </div>
                </td>
                <td class="px-5 py-4 text-right">
                  <span v-if="product.latest_price">
                    <span class="font-medium text-emerald-600 dark:text-emerald-400">Rs {{ formatNum(product.latest_price.sale_rate) }}</span>
                    <span v-if="showPurchasePrice" class="block text-xs text-slate-400 mt-0.5">Buy: Rs {{ formatNum(product.latest_price.purchase_price) }}</span>
                  </span>
                  <span v-else class="text-slate-400 text-xs">—</span>
                </td>
                <td class="px-5 py-4 text-center">
                  <span class="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-semibold"
                    :class="product.stock > 0
                      ? 'bg-emerald-50 dark:bg-emerald-950 text-emerald-600 dark:text-emerald-400'
                      : product.stock === 0
                        ? 'bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400'
                        : 'bg-red-50 dark:bg-red-950 text-red-500 dark:text-red-400'">
                    {{ product.stock }}
                  </span>
                </td>
                <td class="px-5 py-4 text-right">
                  <span v-if="product.latest_price" class="font-medium text-slate-700 dark:text-slate-300">
                    Rs {{ formatNum(product.stock * product.latest_price.sale_rate) }}
                  </span>
                  <span v-else class="text-slate-400 text-xs">—</span>
                </td>
                <td class="px-5 py-4 text-center" @click.stop>
                  <div class="flex items-center justify-center gap-1">
                    <!-- History button -->
                    <a :href="`/products/${product.id}/history`" @click.stop
                      title="View history"
                      class="inline-flex items-center justify-center w-8 h-8 text-slate-500 dark:text-slate-400
                             hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition">
                      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </a>
                    <!-- ⋮ dropdown -->
                    <div class="relative inline-block">
                      <button @click.stop="toggleActionDropdown(product.id)"
                        class="inline-flex items-center justify-center w-8 h-8 text-slate-500 dark:text-slate-400
                               hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition">
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
                        </svg>
                      </button>
                      <div v-if="actionDropdownId === product.id" @click.stop
                        class="absolute right-0 bottom-full mb-1 w-36 bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-slate-200 dark:border-slate-700 z-50 overflow-hidden">
                        <button @click="openEdit(product); actionDropdownId = null"
                          class="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-slate-700 dark:text-slate-300
                                 hover:bg-slate-50 dark:hover:bg-slate-700 transition">
                          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z"/>
                          </svg>
                          Edit
                        </button>
                        <button @click="openDeleteConfirm(product); actionDropdownId = null"
                          class="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-red-600 dark:text-red-400
                                 hover:bg-red-50 dark:hover:bg-red-950 transition border-t border-slate-100 dark:border-slate-700">
                          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"/>
                          </svg>
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <!-- Expanded row -->
              <tr v-if="expandedId === product.id">
                <td colspan="6" class="px-5 pb-5 bg-indigo-50/30 dark:bg-indigo-950/10 border-t border-indigo-100 dark:border-indigo-900/30">
                  <!-- Info cards -->
                  <div class="grid gap-3 mt-4 mb-3" :class="showPurchasePrice ? 'grid-cols-4' : 'grid-cols-3'">
                    <div class="bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 p-3">
                      <p class="text-[10px] text-slate-400 uppercase tracking-wide mb-1">Sale Rate</p>
                      <p class="font-semibold text-emerald-600 dark:text-emerald-400">
                        {{ product.latest_price ? 'Rs ' + formatNum(product.latest_price.sale_rate) : '—' }}
                      </p>
                    </div>
                    <div v-if="showPurchasePrice" class="bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 p-3">
                      <p class="text-[10px] text-slate-400 uppercase tracking-wide mb-1">Purchase Rate</p>
                      <p class="font-semibold text-slate-700 dark:text-slate-300">
                        {{ product.latest_price ? 'Rs ' + formatNum(product.latest_price.purchase_price) : '—' }}
                      </p>
                    </div>
                    <div class="bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 p-3">
                      <p class="text-[10px] text-slate-400 uppercase tracking-wide mb-1">Opening Qty</p>
                      <p class="font-semibold text-slate-700 dark:text-slate-300">{{ product.opening_quantity }}</p>
                    </div>
                    <div class="bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 p-3">
                      <p class="text-[10px] text-slate-400 uppercase tracking-wide mb-1">Price Date</p>
                      <p class="font-semibold text-slate-700 dark:text-slate-300">{{ product.latest_price?.date ?? '—' }}</p>
                    </div>
                  </div>

                  <!-- Value cards -->
                  <div v-if="product.latest_price" class="grid gap-3 mb-4" :class="showPurchasePrice ? 'grid-cols-2' : 'grid-cols-1'">
                    <div v-if="showPurchasePrice" class="bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 p-3">
                      <p class="text-[10px] text-slate-400 uppercase tracking-wide mb-1">
                        Purchase Value &nbsp;·&nbsp; {{ product.stock }} × Rs {{ formatNum(product.latest_price.purchase_price) }}
                      </p>
                      <p class="font-semibold text-slate-700 dark:text-slate-300">
                        Rs {{ formatNum(product.stock * product.latest_price.purchase_price) }}
                      </p>
                    </div>
                    <div class="bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 p-3">
                      <p class="text-[10px] text-slate-400 uppercase tracking-wide mb-1">
                        Sale Value &nbsp;·&nbsp; {{ product.stock }} × Rs {{ formatNum(product.latest_price.sale_rate) }}
                      </p>
                      <p class="font-semibold text-emerald-600 dark:text-emerald-400">
                        Rs {{ formatNum(product.stock * product.latest_price.sale_rate) }}
                      </p>
                    </div>
                  </div>

                  <!-- Price history -->
                  <div v-if="product.prices.length > 0">
                    <p class="text-[10px] font-semibold text-slate-400 uppercase tracking-wide mb-2">Price History</p>
                    <div class="space-y-1.5">
                      <div v-for="(p, pi) in product.prices" :key="p.id"
                        class="flex items-center justify-between bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 px-3 py-2.5 text-sm">
                        <span class="text-slate-400 text-xs">{{ p.date }}</span>
                        <div class="flex items-center gap-3">
                          <span v-if="showPurchasePrice" class="text-xs text-slate-500 dark:text-slate-400">Buy: <span class="font-semibold text-slate-800 dark:text-white">Rs {{ formatNum(p.purchase_price) }}</span></span>
                          <span class="text-xs text-slate-500 dark:text-slate-400">Rate: <span class="font-semibold text-emerald-600 dark:text-emerald-400">Rs {{ formatNum(p.sale_rate) }}</span></span>
                          <span v-if="pi === 0" class="text-[10px] bg-indigo-100 dark:bg-indigo-900 text-indigo-600 dark:text-indigo-400 px-2 py-0.5 rounded-full font-semibold">Latest</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
          <tfoot>
            <tr class="border-t-2 border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50">
              <td colspan="4" class="px-5 py-3.5">
                <span class="text-xs font-semibold text-slate-500 dark:text-slate-400">Total · {{ filtered.length }} product{{ filtered.length !== 1 ? 's' : '' }}</span>
                <span v-if="showPurchasePrice" class="ml-4 text-xs text-slate-400">
                  Purchase: <span class="font-semibold text-slate-600 dark:text-slate-300">Rs {{ formatNum(totalPurchaseAmount) }}</span>
                </span>
              </td>
              <td class="px-5 py-3.5 text-right">
                <span class="font-bold text-slate-800 dark:text-white text-sm">Rs {{ formatNum(totalSaleAmount) }}</span>
              </td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Mobile cards -->
      <div v-if="!loading" class="md:hidden space-y-3">
        <div v-for="(product, i) in filtered" :key="product.id"
          class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-100 dark:border-slate-800 overflow-hidden">
          <!-- Card header -->
          <div class="flex items-center justify-between px-4 py-3.5 cursor-pointer" @click="toggleExpand(product.id)">
            <div class="flex items-center gap-2.5 min-w-0">
              <svg class="w-3.5 h-3.5 text-slate-400 shrink-0 transition-transform duration-200"
                :class="expandedId === product.id ? 'rotate-90 text-indigo-500' : ''"
                fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
              </svg>
              <div class="min-w-0">
                <p class="font-semibold text-slate-800 dark:text-white truncate">{{ product.name }}</p>
                <p class="text-xs mt-0.5"
                  :class="product.stock > 0 ? 'text-emerald-600 dark:text-emerald-400' : product.stock === 0 ? 'text-slate-400' : 'text-red-500 dark:text-red-400'">
                  Stock: {{ product.stock }}
                </p>
              </div>
            </div>
            <div class="text-right shrink-0 ml-3">
              <p class="text-sm font-bold text-emerald-600 dark:text-emerald-400">
                {{ product.latest_price ? 'Rs ' + formatNum(product.latest_price.sale_rate) : '—' }}
              </p>
              <p class="text-[10px] text-slate-400 mt-0.5">sale rate</p>
            </div>
          </div>

          <!-- Expanded details -->
          <div v-if="expandedId === product.id" class="border-t border-indigo-100 dark:border-indigo-900/30 bg-indigo-50/30 dark:bg-indigo-950/10 p-4 space-y-3">
            <!-- Info cards -->
            <div class="grid gap-2 grid-cols-2">
              <div v-if="showPurchasePrice" class="bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 p-3">
                <p class="text-[10px] text-slate-400 uppercase tracking-wide mb-1">Purchase Rate</p>
                <p class="font-semibold text-slate-700 dark:text-slate-300">
                  {{ product.latest_price ? 'Rs ' + formatNum(product.latest_price.purchase_price) : '—' }}
                </p>
              </div>
              <div class="bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 p-3">
                <p class="text-[10px] text-slate-400 uppercase tracking-wide mb-1">Opening Qty</p>
                <p class="font-semibold text-slate-700 dark:text-slate-300">{{ product.opening_quantity }}</p>
              </div>
            </div>

            <!-- Value cards -->
            <div v-if="product.latest_price" class="grid gap-2" :class="showPurchasePrice ? 'grid-cols-2' : 'grid-cols-1'">
              <div v-if="showPurchasePrice" class="bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 p-3">
                <p class="text-[10px] text-slate-400 uppercase tracking-wide mb-1">Purchase Value</p>
                <p class="font-semibold text-slate-700 dark:text-slate-300">Rs {{ formatNum(product.stock * product.latest_price.purchase_price) }}</p>
                <p class="text-[10px] text-slate-400 mt-0.5">{{ product.stock }} × Rs {{ formatNum(product.latest_price.purchase_price) }}</p>
              </div>
              <div class="bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 p-3">
                <p class="text-[10px] text-slate-400 uppercase tracking-wide mb-1">Sale Value</p>
                <p class="font-semibold text-emerald-600 dark:text-emerald-400">Rs {{ formatNum(product.stock * product.latest_price.sale_rate) }}</p>
                <p class="text-[10px] text-slate-400 mt-0.5">{{ product.stock }} × Rs {{ formatNum(product.latest_price.sale_rate) }}</p>
              </div>
            </div>

            <!-- Price history -->
            <div v-if="product.prices.length > 0">
              <p class="text-[10px] font-semibold text-slate-400 uppercase tracking-wide mb-2">Price History</p>
              <div class="space-y-1.5">
                <div v-for="(p, pi) in product.prices" :key="p.id"
                  class="flex items-center justify-between bg-white dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-800 px-3 py-2.5">
                  <span class="text-slate-400 text-xs">{{ p.date }}</span>
                  <div class="flex items-center gap-2 flex-wrap justify-end">
                    <span v-if="showPurchasePrice" class="text-xs text-slate-500">Buy: <span class="font-semibold text-slate-800 dark:text-white">Rs {{ formatNum(p.purchase_price) }}</span></span>
                    <span class="text-xs text-slate-500">Rate: <span class="font-semibold text-emerald-600 dark:text-emerald-400">Rs {{ formatNum(p.sale_rate) }}</span></span>
                    <span v-if="pi === 0" class="text-[10px] bg-indigo-100 dark:bg-indigo-900 text-indigo-600 dark:text-indigo-400 px-2 py-0.5 rounded-full font-semibold">Latest</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action buttons -->
            <div class="grid grid-cols-3 gap-2">
              <a :href="`/products/${product.id}/history`"
                class="flex items-center justify-center gap-1.5 text-sm font-semibold text-slate-600 dark:text-slate-300
                       bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl py-2.5 transition active:scale-95">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                History
              </a>
              <button @click.stop="openEdit(product)"
                class="flex items-center justify-center gap-1.5 text-sm font-semibold text-indigo-600 dark:text-indigo-400
                       bg-white dark:bg-slate-900 border border-indigo-200 dark:border-indigo-800 rounded-xl py-2.5 transition active:scale-95">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z"/>
                </svg>
                Edit
              </button>
              <button @click.stop="openDeleteConfirm(product)"
                class="flex items-center justify-center gap-1.5 text-sm font-semibold text-red-600 dark:text-red-400
                       bg-white dark:bg-slate-900 border border-red-200 dark:border-red-800 rounded-xl py-2.5 transition active:scale-95">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"/>
                </svg>
                Delete
              </button>
            </div>
          </div>
        </div>

      </div>

    </div>

    <!-- ── ADD PRODUCT MODAL ── -->
    <Modal v-if="showAdd" @close="closeAdd">
      <template #title>Add Product</template>
      <form @submit.prevent="submitAdd" class="space-y-4">
        <InputField v-model="addForm.name" label="Product Name" placeholder="e.g. Cement 50kg" required />
        <InputField v-model="addForm.opening_quantity" label="Opening Quantity" placeholder="0" type="number" step="1" />
        <div class="border-t border-slate-100 dark:border-slate-800 pt-4">
          <p class="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">Initial Price (optional)</p>
          <div class="grid grid-cols-2 gap-3">
            <InputField v-model="addForm.purchase_price" label="Purchase Price" placeholder="0.00" type="number" step="0.01" />
            <InputField v-model="addForm.sale_rate" label="Rate" placeholder="0.00" type="number" step="0.01" />
          </div>
          <DatePicker v-model="addForm.date" label="Price Date" class="mt-3" />
        </div>
        <div class="flex gap-3 pt-2">
          <button type="button" @click="closeAdd"
            class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-medium
                   text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition">
            Cancel
          </button>
          <button type="submit" :disabled="addLoading"
            class="flex-1 py-2.5 rounded-xl bg-indigo-500 hover:bg-indigo-400 disabled:opacity-60 text-white text-sm font-semibold transition">
            {{ addLoading ? 'Saving...' : 'Add Product' }}
          </button>
        </div>
      </form>
    </Modal>

    <!-- ── EDIT PRODUCT MODAL ── -->
    <Modal v-if="showEdit" @close="closeEdit">
      <template #title>Edit — {{ editTarget?.name }}</template>
      <div class="space-y-5">

        <!-- Rename -->
        <form @submit.prevent="submitEdit" class="space-y-3">
          <InputField v-model="editForm.name" label="Product Name" required />
          <InputField v-model="editForm.opening_quantity" label="Opening Quantity" type="number" step="1" />
          <button type="submit" :disabled="editLoading"
            class="w-full py-2.5 rounded-xl bg-indigo-500 hover:bg-indigo-400 disabled:opacity-60 text-white text-sm font-semibold transition">
            {{ editLoading ? 'Saving...' : 'Update Product' }}
          </button>
        </form>

        <!-- Add new price -->
        <div class="border-t border-slate-100 dark:border-slate-800 pt-4">
          <p class="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">Add New Price</p>
          <form @submit.prevent="submitPrice" class="space-y-3">
            <div class="grid grid-cols-2 gap-3">
              <InputField v-model="priceForm.purchase_price" label="Purchase Price" placeholder="0.00" type="number" step="0.01" required />
              <InputField v-model="priceForm.sale_rate" label="Rate" placeholder="0.00" type="number" step="0.01" required />
            </div>
            <DatePicker v-model="priceForm.date" label="Date" />
            <button type="submit" :disabled="priceLoading"
              class="w-full py-2.5 rounded-xl bg-emerald-500 hover:bg-emerald-400 disabled:opacity-60 text-white text-sm font-semibold transition">
              {{ priceLoading ? 'Adding...' : 'Add Price' }}
            </button>
          </form>
        </div>

        <!-- Price history -->
        <div v-if="editTarget?.prices?.length" class="border-t border-slate-100 dark:border-slate-800 pt-4">
          <p class="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">Price History</p>
          <div class="space-y-2 max-h-48 overflow-y-auto pr-1">
            <div v-for="(p, i) in editTarget.prices" :key="p.id"
              class="flex items-center justify-between bg-slate-50 dark:bg-slate-800 rounded-xl px-3 py-2.5 text-sm">
              <span class="text-slate-400 text-xs">{{ p.date }}</span>
              <div class="flex items-center gap-3">
                <span class="text-slate-600 dark:text-slate-400 text-xs">Buy: <span class="font-semibold text-slate-800 dark:text-white">Rs {{ formatNum(p.purchase_price) }}</span></span>
                <span class="text-slate-600 dark:text-slate-400 text-xs">Rate: <span class="font-semibold text-emerald-600 dark:text-emerald-400">Rs {{ formatNum(p.sale_rate) }}</span></span>
                <span v-if="i === 0" class="text-[10px] bg-indigo-100 dark:bg-indigo-900 text-indigo-600 dark:text-indigo-400 px-2 py-0.5 rounded-full font-semibold">Latest</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <!-- ── DELETE CONFIRM DIALOG ── -->
    <ConfirmDialog
      v-if="showDeleteConfirm"
      title="Delete Product?"
      :message="`Are you sure you want to delete '${deleteTarget?.name}'? This action cannot be undone.`"
      info-message="Deleting this product won't affect existing invoices, payments, or reports. All historical data will remain intact and accessible."
      confirm-text="Yes, Delete"
      loading-text="Deleting..."
      variant="danger"
      @confirm="confirmDelete"
      @cancel="closeDeleteConfirm"
    />

  </AppLayout>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useForm, usePage, router } from '@inertiajs/vue3'
import AppLayout from '@/layouts/AppLayout.vue'
import Modal from '@/components/Modal.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import InputField from '@/components/InputField.vue'
import DatePicker from '@/components/DatePicker.vue'

defineProps({})
const page = usePage()
const errors = computed(() => page.props.errors)
const businessName = computed(() => page.props.auth?.user?.business_name?.trim() || 'Master Ledger')

const products = ref([])
const loading  = ref(true)

async function fetchData() {
  loading.value = true
  try {
    const res = await fetch('/products/data', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    const json = await res.json()
    products.value = json.products || []
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  document.title = `Products | ${businessName.value}`
  fetchData()
  document.addEventListener('click', closeActionDropdown)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', closeActionDropdown)
})

// ── Column visibility ──────────────────────────────
const showPurchasePrice = ref(false)

// ── Expand ─────────────────────────────────────────
const expandedId = ref(null)
function toggleExpand(id) {
  expandedId.value = expandedId.value === id ? null : id
}

// ── Action dropdown ────────────────────────────────
const actionDropdownId = ref(null)
function toggleActionDropdown(id) {
  actionDropdownId.value = actionDropdownId.value === id ? null : id
}
function closeActionDropdown() {
  actionDropdownId.value = null
}

// ── Search & Sort ──────────────────────────────────
const search  = ref('')
const sortDir = ref(null) // 'asc' | 'desc' | null

function toggleSort() {
  if (sortDir.value === null) sortDir.value = 'desc'
  else if (sortDir.value === 'desc') sortDir.value = 'asc'
  else sortDir.value = null
}

const filtered = computed(() => {
  const q = search.value.trim().toLowerCase()
  let list = q ? products.value.filter(p => p.name.toLowerCase().includes(q)) : [...products.value]
  if (sortDir.value) {
    list = [...list].sort((a, b) => sortDir.value === 'asc' ? a.stock - b.stock : b.stock - a.stock)
  }
  return list
})

// ── Totals ─────────────────────────────────────────
const totalSaleAmount = computed(() =>
  filtered.value.reduce((sum, p) => sum + (p.latest_price ? p.stock * p.latest_price.sale_rate : 0), 0)
)
const totalPurchaseAmount = computed(() =>
  filtered.value.reduce((sum, p) => sum + (p.latest_price ? p.stock * p.latest_price.purchase_price : 0), 0)
)

// ── Utilities ──────────────────────────────────────
function formatNum(n) {
  return Number(n).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

// ── Add product ────────────────────────────────────
const showAdd   = ref(false)
const addLoading = ref(false)
const today = new Date().toISOString().split('T')[0]
const addForm = ref({ name: '', opening_quantity: 0, purchase_price: '', sale_rate: '', date: today })

function openAdd()  { showAdd.value = true }
function closeAdd() { showAdd.value = false; addForm.value = { name: '', opening_quantity: 0, purchase_price: '', sale_rate: '', date: today } }

function submitAdd() {
  addLoading.value = true
  useForm({ product: addForm.value }).post('/products', {
    onSuccess: () => { closeAdd(); fetchData() },
    onFinish: () => { addLoading.value = false }
  })
}

// ── Edit product ───────────────────────────────────
const showEdit    = ref(false)
const editLoading = ref(false)
const editTarget  = ref(null)
const editForm    = ref({ name: '' })

function openEdit(product) {
  editTarget.value = product
  editForm.value   = { name: product.name, opening_quantity: product.opening_quantity }
  priceForm.value  = { purchase_price: '', sale_rate: '', date: today }
  showEdit.value   = true
}
function closeEdit() { showEdit.value = false; editTarget.value = null }

function submitEdit() {
  editLoading.value = true
  useForm({ product: editForm.value }).patch(`/products/${editTarget.value.id}`, {
    onSuccess: () => { closeEdit(); fetchData() },
    onFinish: () => { editLoading.value = false }
  })
}

// ── Add price ──────────────────────────────────────
const priceLoading = ref(false)
const priceForm    = ref({ purchase_price: '', sale_rate: '', date: '' })

function submitPrice() {
  priceLoading.value = true
  useForm({ price: priceForm.value }).post(`/products/${editTarget.value.id}/prices`, {
    onSuccess: () => { closeEdit(); fetchData() },
    onFinish: () => { priceLoading.value = false }
  })
}

// ── Delete product ─────────────────────────────────
const showDeleteConfirm = ref(false)
const deleteTarget = ref(null)

function openDeleteConfirm(product) {
  deleteTarget.value = product
  showDeleteConfirm.value = true
}

function closeDeleteConfirm() {
  showDeleteConfirm.value = false
  deleteTarget.value = null
}

function confirmDelete() {
  return new Promise((resolve) => {
    router.delete(`/products/${deleteTarget.value.id}`, {
      onSuccess: () => {
        closeDeleteConfirm()
        fetchData()
        resolve()
      },
      onError: () => {
        resolve()
      }
    })
  })
}
</script>
